import http from '@/http'
import createCrudModule from 'vuex-crud'

let parseError = res => res
let parseSingle = res => res

export default createCrudModule({
  client: http,
  resource: 'complexes/floors',
  urlRoot: 'complexes/floors',

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`complexes/floors/${id}`, data, config)
        .then(res => {
          let parsedResponse = parseSingle(res)
          commit('updateSuccess', parsedResponse)
          return parsedResponse
        })
        .catch(err => {
          let parsedError = parseError(err)
          commit('updateError', parsedError)
          return Promise.reject(parsedError)
        })
    }
  }
})
